<template>
  <!--弹窗穿梭框-->
  <div class="alertTransfer">
    <el-cascader
      placeholder="输入校名关键字"
      :options="cascaderData"
      filterable
      @keyup.native="handleKeyup"
      @change="changeTransfer"
      :props="props"
      clearable
      change-on-select
    />
  </div>
</template>
<script>
import _ from 'lodash';

export default {
  data() {
    return {
      cascaderData: [],
      cacheKey: '',
      props: {
        label: 'name',
        value: 'id',
        children: 'children',
      },
    };
  },
  methods: {
    /**
       * Description: 子组件把需要的value和label对应赋值，传给父组件
       * Author: yanlichen <yanlichen@tuozhongedu.com>
       */
    changeTransfer(val) {
      let result = [];
      let data = this.cascaderData;
      val.forEach((v) => {
        let k = _.findIndex(data, { id: v });
        result.push({
          name: data[k].name,
          id: v,
          use_org: data[k].use_org
        });
        data = data[k].children;
      });
      this.$emit('cascader-data', result);
      this.handleItemChange(val);
    },
    /**
       * Description: 输入学校请求数据
       * Author: yanlichen <yanlichen@tuozhongedu.com>
       */
    handleKeyup: _.debounce(function(val) {
      let keyWord = val.target.value;
      this.getSchoolName(keyWord).then(({ data }) => {
        this.cascaderData = data;
      });
    }, 500),
    /**
       * Description: 级联操作
       * Author: yanlichen <yanlichen@tuozhongedu.com>
       */
    handleItemChange(val) {
      this.cascaderData.forEach((item, index) => {
        if (val[0] === item.id) {
          if (item.use_org === 1) { // 研究科 -> 还有专业
            this.getSchoolOrg(item.id).then(({ data }) => {
              this.cascaderData[index].children = data; // 学校 -> 研究科
              this.cascaderData[index].children.forEach((itemA, indexA) => {
                if (itemA.id === val[1]) {
                  this.getSchoolMajor(item.id, itemA.id).then(({ data }) => {
                    this.cascaderData[index].children[indexA].children = data; // 研究科 -> 专业
                  });
                }
              });
            });
          } else { // use_org === 0 学校 -> 专业
            this.getSchoolMajor(item.id, 0).then(({ data }) => {
              this.cascaderData[index].children = data;
            });
          }
        }
      });
    },
    /**
       * Description: 选择学校请求
       * Author: yanlichen <yanlichen@tuozhongedu.com>
       */
    getSchoolName(name) {
      return new Promise((resolve) => {
        this.$http._get({
          url: `/index/student/querySchoolName?name=${name}`,
        }).then(({ data }) => {
          resolve(data);
        });
      });
    },
    /**
       * Description: 选择研究科请求
       * Author: yanlichen <yanlichen@tuozhongedu.com>
       */
    getSchoolOrg(shId) {
      return new Promise((resolve) => {
        this.$http._get({
          url: `/index/student/querySchoolOrg?sh_id=${shId}`
        }).then(({ data }) => {
          resolve(data);
        });
      });
    },
    /**
       * Description: 选择专业请求
       * Author: yanlichen <yanlichen@tuozhongedu.com>
       */
    getSchoolMajor(shId, orgId) {
      return new Promise((resolve) => {
        this.$http._get({
          url: `/index/student/querySchoolMajor?sh_id=${shId}&org_id=${orgId}`
        }).then(({ data }) => {
          resolve(data);
        });
      });
    },
  }
};
</script>
<style src="../../assets/css/fontFace.css"></style>
<style>
  .el-cascader{
    width: 50%;
  }
  .el-cascader-menus{
    width: 47%;
  }
  .el-cascader-menu{
    width: 33%;
    height:310px !important;
  }
  .alertTransfer{
    height:350px;
  }
</style>
